import { tracked } from '@glimmer/tracking';

import FilterSortBoard from 'webapp/models-custom/filter-sort/board';

export default class FilterSortBoardInList extends FilterSortBoard {
	@tracked override viewId = 'table';
	override itemDomSelector = '.table-row:not(.empty)';
}
